import {
  Benefits,
  NewWay,
  Hero,
  QuickTour,
  WhyTrackmate,
  Plans,
  MainFeatures,
  // Reviews,
  Download,
} from "@/components/Home";

const Home = () => {
  return (
    <>
      <Hero />
      <Benefits />
      <NewWay />
      <QuickTour />
      <WhyTrackmate />
      <Plans />
      <MainFeatures />
      <Download />
      {/* <Reviews /> */}
    </>
  );
};

export default Home;
